(() => {
  document.querySelectorAll('.section-listing-projects').forEach((root) => {
    const restBase  = root.dataset.rest;
    const endpoint  = root.dataset.endpoint || 'projects';
    const perPage   = parseInt(root.dataset.perPage || '8', 10);
    const nonce     = root.dataset.nonce;

    const grid      = root.querySelector('.section-listing-projects__list__grid');
    const moreBtn   = root.querySelector('.section-listing-projects__list__more');
    const emptyMsg  = root.querySelector('.section-listing-projects__list__no-results');

    const selIndustry = root.querySelector('.filter__select[data-filter="industry"]');
    const selService  = root.querySelector('.filter__select[data-filter="service"]');

    const cache = new Map();
    let page = 1, totalPages = 1;

    const qs  = (sel, ctx = document) => ctx.querySelector(sel);
    const qsa = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

    const buildUrl = ({ page, industry, service }) => {
      const p = new URLSearchParams();
      p.set('per_page', String(perPage));
      p.set('page',     String(page));
      p.set('_embed',   '1');
      if (industry) p.set('industries', industry);
      if (service)  p.set('services',  service);
      return `${restBase}/${endpoint}?${p.toString()}`;
    };

    function hydrateSelect(selectEl) {
      const btn    = qs('.filter__select__button', selectEl);
      const list   = qs('.filter__select__list',   selectEl);
      const value  = qs('.filter__select__value',  selectEl);
      const native = qs('.filter__select__native', selectEl);

      function open()  { selectEl.classList.add('is-open');  btn.setAttribute('aria-expanded','true');  list.setAttribute('aria-hidden','false'); }
      function close() { selectEl.classList.remove('is-open'); btn.setAttribute('aria-expanded','false'); list.setAttribute('aria-hidden','true'); }

      close();

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const opened = selectEl.classList.contains('is-open');
        opened ? close() : open();
      });

      qsa('[role="option"]', list).forEach(li => {
        li.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const val = li.dataset.value || '';
          if (native.value !== val) {
            native.value = val;
            value.textContent = li.textContent.trim();
            qsa('[role="option"]', list).forEach(o => o.setAttribute('aria-selected','false'));
            li.setAttribute('aria-selected','true');
            selectEl.dispatchEvent(new CustomEvent('dook:change', { bubbles: true }));
          }
          close();
        });
      });

      document.addEventListener('click', (e) => {
        if (!selectEl.contains(e.target)) close();
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') close();
      });

      selectEl.addEventListener('keydown', (e) => {
        const opts = qsa('[role="option"]', list);
        const current = opts.findIndex(o => o.getAttribute('aria-selected') === 'true');
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          open();
          const next = Math.min(opts.length - 1, current + 1);
          opts.forEach(o => o.setAttribute('data-focus','0'));
          opts[next].setAttribute('data-focus','1'); opts[next].focus?.();
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          open();
          const prev = Math.max(0, current - 1);
          opts.forEach(o => o.setAttribute('data-focus','0'));
          opts[prev].setAttribute('data-focus','1'); opts[prev].focus?.();
        } else if (e.key === 'Enter') {
          const foc = opts.find(o => o.getAttribute('data-focus') === '1') || opts[current];
          if (foc) foc.click();
        }
      });

      list.tabIndex = -1;
      btn.tabIndex  = 0;
    }

    [selIndustry, selService].forEach(hydrateSelect);

    async function fetchProjects(url) {
      if (cache.has(url)) return cache.get(url);
      const res = await fetch(url, { headers: { 'X-WP-Nonce': nonce } });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const totalPages = parseInt(res.headers.get('X-WP-TotalPages') || '1', 10);
      const json = await res.json();
      const out = { json, totalPages };
      cache.set(url, out);
      return out;
    }

    function card(item) {
      const title = item.title?.rendered || '';
      const link  = item.link;

      const media = item._embedded?.['wp:featuredmedia']?.[0];
      const sizes = media?.media_details?.sizes || {};

      const imgLg = sizes['project-teaser-lg']?.source_url;
      const imgMd = sizes['project-teaser-md']?.source_url;
      const imgML = sizes['project-teaser-lg']?.source_url;
      const imgLgWP = sizes['project-teaser-lg']?.source_url;
      const imgSrc = imgLg || imgMd || imgML || imgLgWP || media?.source_url || '';

      const srcsetParts = [];
      if (imgMd && sizes['project-teaser-md']?.width) {
        srcsetParts.push(`${imgMd} ${sizes['project-teaser-md'].width}w`);
      }
      if (imgLg && sizes['project-teaser-lg']?.width) {
        srcsetParts.push(`${imgLg} ${sizes['project-teaser-lg'].width}w`);
      }
      if (imgML && sizes['project-teaser-lg']?.width) {
        srcsetParts.push(`${imgML} ${sizes['project-teaser-lg'].width}w`);
      }
      if (imgLgWP && sizes['project-teaser-lg']?.width) {
        srcsetParts.push(`${imgLgWP} ${sizes['project-teaser-lg'].width}w`);
      }
      const srcsetAttr = srcsetParts.length ? `srcset="${srcsetParts.join(', ')}"` : '';
      const sizesAttr  = srcsetParts.length ? `sizes="(min-width: 1024px) 50vw, 100vw"` : '';

      const industries = (item.industries || []).map(t=>t.name).join(', ');
      const services   = (item.services   || []).map(t=>t.name).join(', ');
      const excerpt    = (item.excerpt?.rendered || '').replace(/<[^>]+>/g,'').trim();

      const root = document.querySelector('.section-listing-projects');
      const tReadMore = root?.dataset?.readMore || 'Read more →';

      return `
        <li>
          <article class="project-teaser">
            <figure class="project-teaser__thumb">
              <a href="${link}">
                ${imgSrc
                ? `<img src="${imgSrc}" ${srcsetAttr} ${sizesAttr} alt="" loading="lazy" decoding="async">`
                : `<div class="thumb--ph"></div>`}
              </a>
            </figure>
            <div class="project-teaser__body">
              <h3 class="heading-3"><a href="${link}" class="project-teaser__body__link" aria-label="${tReadMore}: ${title}">${title}</a></h3>
              ${excerpt ? `<p class="body-regular-5">${excerpt.slice(0,480)}${excerpt.length>480?'…':''}</p>` : ''}
              <ul class="project-teaser__body__meta">
                <li><span class="body-regular-7">Industry</span><span class="body-regular-5">${industries}</span></li>
                <li><span class="body-regular-7">Service</span><span class="body-regular-5">${services}</span></li>
              </ul>
              <a class="btn btn--v7" href="${link}"><span class="body-semibold-5" aria-label="${tReadMore}: ${title}">${tReadMore}</span></a>
            </div>
          </article>
        </li>
      `;
    }

    async function load({ reset=false } = {}) {
      emptyMsg.hidden = true;
      const industry = qs('.filter__select__native', selIndustry).value || '';
      const service  = qs('.filter__select__native', selService).value  || '';
      const url = buildUrl({ page, industry, service });

      root.classList.add('is-loading');

      try {
        const { json, totalPages: tp } = await fetchProjects(url);
        totalPages = tp;

        if (reset) grid.innerHTML = '';
        if (!json.length && page === 1) {
          emptyMsg.hidden = false;
          moreBtn.hidden = true;
          return;
        }

        grid.insertAdjacentHTML('beforeend', json.map(card).join(''));
        const hasMore = page < totalPages;
        moreBtn.hidden = !hasMore;
      } catch (err) {
        console.error(err);
        if (reset) { grid.innerHTML = ''; }
        emptyMsg.hidden = false;
        moreBtn.hidden = true;
      } finally {
        root.classList.remove('is-loading');
      }
    }

    function onFilterChange() {
      page = 1;
      // [NEW] keep hash in sync with current selection
      updateHashFromSelection();               // [NEW]
      load({ reset: true });
    }
    selIndustry.addEventListener('dook:change', onFilterChange);
    selService .addEventListener('dook:change', onFilterChange);

    moreBtn.addEventListener('click', (e) => {
      e.preventDefault();
      if (page >= totalPages) return;
      page += 1;
      load({ reset: false });
    });

    // ------------------------------
    // Hash <-> Filters integration
    // ------------------------------

    // [NEW] slugify helper (roughly matches WP slugs)
    function slugify(str='') {                 // [NEW]
      return String(str)
        .toLowerCase()
        .normalize('NFD').replace(/[\u0300-\u036f]/g,'')
        .replace(/[^a-z0-9]+/g,'-')
        .replace(/^-+|-+$/g,'');
    }

    // [NEW] Get option map for a select (id/label/slug/el)  // [NEW]
    function getOptionsMap(selectEl) {
      const list = qs('.filter__select__list', selectEl);
      const opts = qsa('[role="option"]', list).filter(li => li.dataset.value !== undefined);
      return opts
        .map(li => {
          const id    = li.dataset.value || '';
          const label = li.textContent.trim();
          const slug  = li.dataset.slug || slugify(label);
          return { id, label, slug, el: li };
        })
        .filter(o => o.id !== ''); // skip "All …"
    }

    // [NEW] Find in map by slug or numeric id string        // [NEW]
    function findBySlug(map, slugOrId) {
      if (!slugOrId) return null;
      // numeric ID support
      const byId = map.find(o => o.id === String(slugOrId));
      if (byId) return byId;
      const s = slugify(slugOrId);
      return map.find(o => o.slug === s) || null;
    }

    // [NEW] Programmatically set selection without double loading  // [NEW]
    function programmaticSelect(selectEl, termId, termLabel, {dispatch=false}={}) {
      const native = qs('.filter__select__native', selectEl);
      const list   = qs('.filter__select__list', selectEl);
      const value  = qs('.filter__select__value', selectEl);
      if (!native) return;

      native.value = termId || '';
      value.textContent = termLabel || (native.value ? termLabel : value.dataset.placeholder || '');

      // ARIA selected sync
      qsa('[role="option"]', list).forEach(o => {
        const isMatch = (o.dataset.value || '') === String(termId || '');
        o.setAttribute('aria-selected', isMatch ? 'true' : 'false');
      });

      if (dispatch) {
        selectEl.dispatchEvent(new CustomEvent('dook:change', { bubbles: true }));
      }
    }

    // [NEW] Parse hash into {industry, service} or {slug}    // [NEW]
    function parseHash() {
      const raw = (location.hash || '').replace(/^#/, '').trim();
      const out = {};
      if (!raw) return out;

      // support formats: industry=slug&service=slug
      // also tolerate separators like "industry:slug" or "industry/slug"
      const parts = raw.split(/[&;]/).filter(Boolean);
      if (parts.length > 1) {
        parts.forEach(p => {
          const m = p.match(/^(\w+)[=:/](.+)$/);
          if (m) {
            const key = m[1].toLowerCase();
            const val = decodeURIComponent(m[2]);
            if (key.startsWith('industry')) out.industry = val;
            if (key.startsWith('service'))  out.service  = val;
          }
        });
        return out;
      }

      // single token: treat as a bare slug
      out.slug = decodeURIComponent(raw);
      return out;
    }

    // [NEW] Apply hash to selects, then load once            // [NEW]
    function applyHashFilters() {
      const h = parseHash();
      const indMap = getOptionsMap(selIndustry);
      const srvMap = getOptionsMap(selService);

      let changed = false;

      if (h.industry) {
        const m = findBySlug(indMap, h.industry);
        if (m) {
          programmaticSelect(selIndustry, m.id, m.label, { dispatch: false });
          changed = true;
        }
      }
      if (h.service) {
        const m = findBySlug(srvMap, h.service);
        if (m) {
          programmaticSelect(selService, m.id, m.label, { dispatch: false });
          changed = true;
        }
      }

      if (!h.industry && !h.service && h.slug) {
        // bare slug: try industry first, then service
        const mInd = findBySlug(indMap, h.slug);
        const mSrv = mInd ? null : findBySlug(srvMap, h.slug);
        if (mInd) {
          programmaticSelect(selIndustry, mInd.id, mInd.label, { dispatch: false });
          changed = true;
        } else if (mSrv) {
          programmaticSelect(selService, mSrv.id, mSrv.label, { dispatch: false });
          changed = true;
        }
      }

      page = 1;
      // normalize hash to key=value form after applying
      updateHashFromSelection(); // keeps URL tidy             // [NEW]
      load({ reset: true });     // single load                 // [NEW]
    }

    // [NEW] Build hash from current selection (slugs)        // [NEW]
    function updateHashFromSelection() {
      const indNative = qs('.filter__select__native', selIndustry);
      const srvNative = qs('.filter__select__native', selService);
      const indVal = indNative?.value || '';
      const srvVal = srvNative?.value || '';

      const indMap = getOptionsMap(selIndustry);
      const srvMap = getOptionsMap(selService);

      const indSel = indMap.find(o => o.id === String(indVal));
      const srvSel = srvMap.find(o => o.id === String(srvVal));

      let hash = '';
      if (indSel) hash += (hash ? '&' : '') + `industry=${encodeURIComponent(indSel.slug)}`;
      if (srvSel) hash += (hash ? '&' : '') + `service=${encodeURIComponent(srvSel.slug)}`;

      const base = location.pathname + location.search;
      if (hash) {
        history.replaceState(null, '', `${base}#${hash}`);
      } else {
        history.replaceState(null, '', base);
      }
    }

    // [NEW] react to back/forward hash changes               // [NEW]
    window.addEventListener('hashchange', () => {
      page = 1;
      applyHashFilters();
    });

    // INIT
    applyHashFilters();      // [CHANGED] replaces plain load on first paint
    // load({ reset: true }); // (removed – handled in applyHashFilters)
  });
})();
